import * as React from 'react';
import styled, {css} from 'styled-components';
import {Container as ButtonContainer, ButtonVariant} from 'components/Button';
import {transparentize} from 'polished';
import {IconLoading} from "icons";
import {fetchCounters, FetchInstanceType} from "api/counters";
import {Theme} from '../../../stores/AppStore';

export enum ButtonLabel {
  Neuter='Создать новое',
  Feminine='Создать новую',
  Masculine='Создать новый',
  Navigate='Перейти',
}

export interface ContentCardProps {
  title: string;
  type: FetchInstanceType;
  btnLabel: ButtonLabel;
  onBtnClick: () => void;
}

export const IconBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({theme}) => theme.colors.primary};
  height: 40px;
  width: 40px;
  border-radius: 50%;
  background-repeat: no-repeat;
  background-position: center;
`;

export const Container = styled.div<{type: FetchInstanceType}>`
  height: 194px;
  width: 190px;
  min-width: 190px;
  border-radius: 5px;
  padding: 20px 19px;
  box-sizing: border-box;

  ${({theme}) => {
    switch (theme.name) {
      case Theme.Dark: return css`
        border: 1px solid ${theme.variables.tableBorderColor};
      `;
      case Theme.Light: return css`
        background-color: ${theme.variables.accentBackgroundColor};
        border: 1px solid ${theme.variables.borderColor};
      `;
    }
  }};
  
  ${IconBox} {
    ${({type}) => {
    switch (type) {
      case 'courses': return css`
        background-image: url("data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg clip-path='url(%23clip0)'%3E%3Cpath d='M19.677 5.96451L10.2624 1.24943C10.0972 1.16669 9.90273 1.16669 9.73757 1.24943L0.322998 5.96451C-0.107353 6.18005 -0.107978 6.79646 0.322998 7.01228L9.73757 11.7274C9.90269 11.8101 10.0973 11.8101 10.2624 11.7274L12.9689 10.3719V9.77927L9.12538 7.6038C8.84374 7.44439 8.74464 7.08689 8.90409 6.80525C9.06355 6.52365 9.42112 6.42459 9.70265 6.58396L13.8435 8.92771C14.0273 9.03169 14.1409 9.2265 14.1409 9.43763V9.78498L19.677 7.01232C20.1074 6.79677 20.108 6.18037 19.677 5.96451Z' fill='white'/%3E%3Cpath d='M12.9688 12.9627V11.6825L10.7871 12.7752C10.3005 13.0189 9.71623 13.0274 9.21256 12.7752L3.5542 9.94131V13.1096C3.5542 13.2153 3.58279 13.319 3.63701 13.4099C5.04178 15.7634 9.35557 16.2036 12.1394 15.7247C11.3742 14.7621 11.8149 13.3414 12.9688 12.9627Z' fill='white'/%3E%3Cpath d='M14.1409 12.9905C14.7781 13.2338 15.2387 13.8373 15.2717 14.551C15.72 14.2357 16.0953 13.858 16.3629 13.4098C16.4171 13.3191 16.4457 13.2153 16.4457 13.1095V9.94128L14.1409 11.0956V12.9905Z' fill='white'/%3E%3Cpath d='M14.7135 15.918C14.0381 16.5478 12.9948 16.5491 12.318 15.918L11.4158 17.993C11.2478 18.3793 11.5314 18.8126 11.9532 18.8126H15.0784C15.4996 18.8126 15.784 18.3799 15.6157 17.993L14.7135 15.918Z' fill='white'/%3E%3Cpath d='M13.5159 15.2189C13.8395 15.2189 14.1018 14.9565 14.1018 14.6329C14.1018 14.3093 13.8395 14.047 13.5159 14.047C13.1923 14.047 12.9299 14.3093 12.9299 14.6329C12.9299 14.9565 13.1923 15.2189 13.5159 15.2189Z' fill='white'/%3E%3C/g%3E%3Cdefs%3E%3CclipPath id='clip0'%3E%3Crect width='20' height='20' fill='white'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E%0A");
      `;
      case 'lessons': return css`
        background-image: url("data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M9.20682 15.1201C8.71726 14.2162 7.7601 13.6009 6.66224 13.6009H5.50578C5.1866 13.6009 4.92755 13.3419 4.92755 13.0227V3.19284H3.7711C3.45176 3.19284 3.19287 3.45173 3.19287 3.77107V14.7574H7.81869C8.31019 14.7574 8.78703 14.8861 9.20682 15.1201Z' fill='white'/%3E%3Cpath d='M9.55335 13.6622V4.92752C9.55335 3.33022 8.25249 2.03638 6.66221 2.03638C6.34284 2.03638 6.08398 2.29523 6.08398 2.6146V12.4445H6.66221C7.79361 12.4445 8.81823 12.9109 9.55335 13.6622Z' fill='white'/%3E%3Cpath d='M17.0702 14.7574V3.77107C17.0702 3.45173 16.8113 3.19284 16.492 3.19284H12.4444C11.488 3.19284 10.7097 3.97114 10.7097 4.92752V15.3456C11.2039 14.9706 11.8118 14.7574 12.4444 14.7574H17.0702Z' fill='white'/%3E%3Cpath d='M20 4.9275C20 4.60832 19.741 4.34927 19.4218 4.34927H18.2268V15.3356C18.2268 15.6548 17.9677 15.9138 17.6486 15.9138H12.4445C11.8266 15.9138 11.2688 16.2388 10.9523 16.7827C10.8486 16.9608 10.6582 17.0703 10.4523 17.0703H9.81088C9.60503 17.0703 9.4146 16.9608 9.31091 16.7827C8.99442 16.2388 8.43663 15.9138 7.81869 15.9138H2.61464C2.29546 15.9138 2.03642 15.6548 2.03642 15.3356V4.34927H0.841411C0.52223 4.34927 0.263184 4.60832 0.263184 4.9275V17.6485C0.263184 17.9677 0.52223 18.2267 0.841411 18.2267H19.4218C19.741 18.2267 20 17.9677 20 17.6485V4.9275Z' fill='white'/%3E%3C/svg%3E%0A");  
      `;
      case 'webinars': return css`
        background-image: url("data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M5.50572 14.7575C5.82506 14.7575 6.08395 14.4986 6.08395 14.1793C6.08395 13.86 5.82506 13.6011 5.50572 13.6011C5.18637 13.6011 4.92749 13.86 4.92749 14.1793C4.92749 14.4986 5.18637 14.7575 5.50572 14.7575Z' fill='white'/%3E%3Cpath d='M8.39697 7.02002V9.77454L11.1515 8.39728L8.39697 7.02002Z' fill='white'/%3E%3Cpath d='M18.2653 2.03662H1.99787C1.04132 2.03662 0.263184 2.81476 0.263184 3.7713V16.4923C0.263184 17.4489 1.04132 18.227 1.99787 18.227H18.2653C19.2219 18.227 20 17.4489 20 16.4923V3.7713C20 2.81476 19.2219 2.03662 18.2653 2.03662ZM7.24047 6.08422C7.24047 5.88376 7.34435 5.69796 7.51489 5.59237C7.68485 5.48679 7.89718 5.47831 8.07732 5.56697L12.7031 7.87988C12.8991 7.97814 13.0227 8.17802 13.0227 8.39713C13.0227 8.61624 12.8991 8.81611 12.7031 8.91437L8.07732 11.2273C7.89479 11.3179 7.68219 11.3059 7.51489 11.2019C7.34435 11.0963 7.24047 10.9105 7.24047 10.71V6.08422ZM17.0703 14.7576H7.13396C6.89445 15.4292 6.25863 15.9141 5.50578 15.9141C4.75293 15.9141 4.11711 15.4292 3.87761 14.7576H3.19287C2.87327 14.7576 2.61464 14.499 2.61464 14.1794C2.61464 13.8598 2.87327 13.6012 3.19287 13.6012H3.87761C4.11711 12.9296 4.75293 12.4447 5.50578 12.4447C6.25863 12.4447 6.89445 12.9296 7.13396 13.6012H17.0703C17.3899 13.6012 17.6486 13.8598 17.6486 14.1794C17.6486 14.499 17.3899 14.7576 17.0703 14.7576Z' fill='white'/%3E%3C/svg%3E%0A");  
      `;
      case 'tasks': return css`
        background-image: url("data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg clip-path='url(%23clip0)'%3E%3Cpath d='M13.5624 2.57605H12.406V3.15428C12.406 4.11082 11.6278 4.88896 10.6713 4.88896H4.88901C3.93246 4.88896 3.15432 4.11082 3.15432 3.15428V2.57605H1.99787C1.04132 2.57605 0.263184 3.39274 0.263184 4.34928V18.2653C0.263184 19.2218 1.04132 20 1.99787 20H13.5624C14.519 20 15.3357 19.2218 15.3357 18.2653V4.31073C15.3357 3.35419 14.519 2.57605 13.5624 2.57605ZM5.87608 16.6229C6.10193 16.8488 6.10193 17.2147 5.87608 17.4406C5.65019 17.6665 5.28432 17.6665 5.05843 17.4406L4.31078 16.6929L3.56313 17.4406C3.33724 17.6665 2.97137 17.6665 2.74548 17.4406C2.51962 17.2147 2.51962 16.8488 2.74548 16.6229L3.49313 15.8753L2.74552 15.1276C2.51966 14.9018 2.51966 14.5358 2.74552 14.31C2.97137 14.0841 3.33731 14.0841 3.56317 14.31L4.31078 15.0576L5.05843 14.31C5.28428 14.0841 5.65022 14.0841 5.87608 14.31C6.10193 14.5358 6.10193 14.9018 5.87608 15.1276L5.12843 15.8753L5.87608 16.6229ZM7.03253 10.5018L4.71962 12.8147C4.60668 12.9277 4.45873 12.9842 4.31082 12.9842C4.16291 12.9842 4.01492 12.9277 3.90201 12.8147L2.74555 11.6583C2.51962 11.4324 2.51962 11.0665 2.74552 10.8407C2.97137 10.6148 3.33731 10.6148 3.56317 10.8407L4.31078 11.5883L6.21488 9.68417C6.44074 9.45831 6.80668 9.45831 7.03253 9.68417C7.25839 9.91002 7.25839 10.276 7.03253 10.5018ZM7.03253 7.03245L4.71962 9.34536C4.60668 9.45831 4.45873 9.51478 4.31082 9.51478C4.16291 9.51478 4.01492 9.45831 3.90201 9.34536L2.74555 8.18891C2.51962 7.96305 2.51962 7.59715 2.74552 7.37129C2.97137 7.14544 3.33731 7.14544 3.56317 7.37129L4.31078 8.1189L6.21488 6.2148C6.44074 5.98894 6.80668 5.98894 7.03253 6.2148C7.25839 6.44065 7.25839 6.8066 7.03253 7.03245ZM12.406 16.4535H8.9366C8.61699 16.4535 8.35837 16.1949 8.35837 15.8753C8.35837 15.5557 8.61699 15.2971 8.9366 15.2971H12.406C12.7256 15.2971 12.9842 15.5557 12.9842 15.8753C12.9842 16.1949 12.7256 16.4535 12.406 16.4535ZM12.406 12.9842H8.9366C8.61699 12.9842 8.35837 12.7255 8.35837 12.4059C8.35837 12.0863 8.61699 11.8277 8.9366 11.8277H12.406C12.7256 11.8277 12.9842 12.0863 12.9842 12.4059C12.9842 12.7255 12.7256 12.9842 12.406 12.9842ZM12.406 9.51478H8.9366C8.61699 9.51478 8.35837 9.25616 8.35837 8.93656C8.35837 8.61695 8.61699 8.35833 8.9366 8.35833H12.406C12.7256 8.35833 12.9842 8.61695 12.9842 8.93656C12.9842 9.25616 12.7256 9.51478 12.406 9.51478Z' fill='white'/%3E%3Cpath d='M10.0931 1.41961H9.00777L8.87112 1.03451C8.70737 0.57316 8.26918 0.263153 7.78016 0.263153C7.29113 0.263153 6.85295 0.57316 6.6892 1.03451L6.55254 1.41961H5.46725C4.82854 1.41961 4.31079 1.93735 4.31079 2.57606V3.15429C4.31079 3.47363 4.56968 3.73252 4.88902 3.73252H10.6713C10.9906 3.73252 11.2495 3.47363 11.2495 3.15429V2.57606C11.2495 1.93735 10.7318 1.41961 10.0931 1.41961Z' fill='white'/%3E%3Cpath d='M18.2656 14.8185C17.6806 14.8184 17.2783 15.3286 16.8179 15.789L17.6786 18.4097C17.7571 18.6458 18.0164 18.805 18.2654 18.805C18.5144 18.805 18.7352 18.6458 18.8137 18.4097L19.6744 15.789C19.2159 15.3305 18.8506 14.8186 18.2656 14.8185Z' fill='white'/%3E%3Cpath d='M18.2654 3.73251C17.3089 3.73251 16.4922 4.51065 16.4922 5.4672V6.04542H20.0001V5.4672C20.0001 4.51065 19.222 3.73251 18.2654 3.73251Z' fill='white'/%3E%3Cpath d='M16.4922 7.20187V14.4794C16.9857 13.9858 17.4853 13.6629 18.2654 13.6629C19.0455 13.6629 19.5066 13.9858 20.0001 14.4794V7.20187H16.4922Z' fill='white'/%3E%3C/g%3E%3Cdefs%3E%3CclipPath id='clip0'%3E%3Crect width='20' height='20' fill='white'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E%0A");  
      `;
      case 'tasksCheck': return css`
        background-color: ${({theme}) => theme.colors.red};
        background-image: url("data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M9.45947 0.474976V5.40529H14.3899L9.45947 0.474976Z' fill='white'/%3E%3Cpath d='M7.29727 17.838V16.7387C7.29727 16.0889 7.55035 15.4781 8.00976 15.0187L8.97431 14.0542H4.32416C3.87637 14.0542 3.51334 13.6911 3.51334 13.2434C3.51334 12.7956 3.87637 12.4325 4.32416 12.4325H10.5959L14.7484 8.28001C14.786 8.24234 14.8251 8.20655 14.8647 8.17169V7.02692H8.64847C8.20068 7.02692 7.83765 6.66389 7.83765 6.2161V0H1.08084C0.633049 0 0.27002 0.36303 0.27002 0.810817V17.0272C0.27002 17.475 0.633049 17.838 1.08084 17.838H7.29727ZM4.32416 9.18926H10.8107C11.2585 9.18926 11.6215 9.55229 11.6215 10.0001C11.6215 10.4479 11.2585 10.8109 10.8107 10.8109H4.32416C3.87637 10.8109 3.51334 10.4479 3.51334 10.0001C3.51334 9.55229 3.87637 9.18926 4.32416 9.18926Z' fill='white'/%3E%3Cpath d='M19.4924 11.8771L17.0419 9.4266C16.8836 9.26828 16.676 9.18909 16.4686 9.18909C16.2611 9.18909 16.0535 9.26828 15.8952 9.4266L14.8649 10.457L9.15646 16.1655C9.00441 16.3175 8.91895 16.5237 8.91895 16.7388V17.838V19.1892C8.91895 19.637 9.28198 20 9.72976 20H12.1802C12.3952 20 12.6015 19.9146 12.7535 19.7625L19.4924 13.0238C19.6445 12.8717 19.7299 12.6655 19.7299 12.4505C19.7299 12.2354 19.6444 12.0292 19.4924 11.8771Z' fill='white'/%3E%3C/svg%3E%0A"); 
      `;
    }
  }};
  }
`;

export const Title = styled.div`
  margin-top: 20px;
  margin-bottom: 6px;
`;

export const Value = styled.div`
  margin-bottom: 10px;
  font-size: 14px;
  ${({theme}) => {
    switch (theme.name) {
      case Theme.Dark: return css`
        color: ${transparentize(.6, theme.colors.white)};
      `;
      case Theme.Light: return css`
        color: ${transparentize(.6, theme.variables.color)};
      `;
    }
  }};
`;

export const Button = styled(ButtonContainer)`
  padding: 11px 16px;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  text-align: center;
  border-radius: 5px;
  cursor: pointer;
`;

/**
 * The function render Category item
 * @param {ContentCard} props
 * @constructor
 */
export default function ContentCard(props: ContentCardProps) {
  const [count, setCount] = React.useState<string | null>(null)

  function getCountLabel(value: number) {
    switch (props.type) {
      case "courses":
        return value + ' курсов';
      case "lessons":
        return value + ' уроков';
      case "webinars":
        return value + ' трансляции';
      case "tasks":
        return value + ' заданий';
      case "tasksCheck":
        return value + ' на проверку';
      default:
        return String(value)
    }
  }

  /**
   * The function render value or loading icon
   * @constructor
   */
  React.useEffect(() => {
    async function getCount() {
      const value = await fetchCounters(props.type);

      if (typeof value === 'number') {
        setCount(getCountLabel(value))
      } else {
        setCount(getCountLabel(0))
      }
    }

    getCount()
  }, [])

  /**
   * The function render value or loading icon
   * @constructor
   */
  function renderBody() {
    if (count) {
      return (
        <React.Fragment>
          <Value>{count}</Value>
          <Button
            variant={ButtonVariant.Outline}
            onClick={props.onBtnClick}
          >
            {props.btnLabel}
          </Button>
        </React.Fragment>
      )
    }

    return <IconLoading />
  }

  return (
    <Container type={props.type}>
      <IconBox />
      <Title>{props.title}</Title>
      {renderBody()}
    </Container>
  );
}
